import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "outer",
      d: "M4.29297 10.936C4.29297 16.304 12.3057 22.3432 12.3057 22.3432C12.3057 22.3432 20.3184 16.304 20.3184 10.936C20.3184 6.48887 16.731 2.88379 12.3057 2.88379C7.88038 2.88379 4.29297 6.48887 4.29297 10.936Z",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      class: "inner",
      d: "M13.3623 10.8931C13.3623 11.4763 12.8894 11.9492 12.3061 11.9492C11.7228 11.9492 11.25 11.4763 11.25 10.8931C11.25 10.3098 11.7228 9.83691 12.3061 9.83691C12.8894 9.83691 13.3623 10.3098 13.3623 10.8931Z",
      fill: "#454342",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }